import { render, staticRenderFns } from "./MastheadStoryBackIcon.vue?vue&type=template&id=a6da37d4&"
import script from "./MastheadStoryBackIcon.vue?vue&type=script&lang=js&"
export * from "./MastheadStoryBackIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports